import { createSelector } from "@reduxjs/toolkit";
import { SPORT_COURT_STATUS, SportCourt } from "apis/SportCourtAPI";
import { SportCourtState } from "store/reducers/sportCourtReducer";
import { RootState } from "store/store";

const sportCourtSelector = (state: RootState) => state.sportCourtState;

export const getSportCourtState = createSelector(
  sportCourtSelector,
  (state: SportCourtState) => state
);

export const getActiveSportCourtState = createSelector(
  sportCourtSelector,
  (state: SportCourtState) => {
    return state.sportCourts.filter(
      (sportCourt: SportCourt) =>
        sportCourt.status === SPORT_COURT_STATUS.ACTIVE
    );
  }
);

export const getSportCourtName = createSelector(
  sportCourtSelector,
  (state: SportCourtState) => (sportCourtId: string) => {
    return state.sportCourts.find(
      (sportCourt: SportCourt) =>
        sportCourt.id === sportCourtId &&
        sportCourt.status === SPORT_COURT_STATUS.ACTIVE
    );
  }
);
